module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Regular Italic TH.c6e3f239.woff2";